import { render, staticRenderFns } from "./PendingApprovalIncident.vue?vue&type=template&id=38eebc78"
import script from "./PendingApprovalIncident.vue?vue&type=script&lang=ts"
export * from "./PendingApprovalIncident.vue?vue&type=script&lang=ts"
import style0 from "./PendingApprovalIncident.vue?vue&type=style&index=0&id=38eebc78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports